var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6998D203B7173B478D2A6C94345Bedf259Bbb642(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2538 2231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2001_17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1269,
    cy: 1115.5,
    rx: 585,
    ry: 431.5,
    fill: "var(--fill-0, #01C281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2001_17",
    x: 0,
    y: 0,
    width: 2538,
    height: 2231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 342,
    result: "effect1_foregroundBlur_2001_17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6998D203B7173B478D2A6C94345Bedf259Bbb642);
export default __webpack_public_path__ + "static/media/6998d203b7173b478d2a6c94345bedf259bbb642.c9251da2b3f3e8f864621e94cd1619d3.svg";
export { ForwardRef as ReactComponent };